import Framework from '@Framework/index';
import Vue from 'vue';
import App from './App.vue';
import store from './store';
import registerRouter from './router';
import './registerServiceWorker';
Vue.config.productionTip = false;
Vue.use(Framework);
const router = registerRouter(store);
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
